document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', function (e) {
    var addToCartBtn = e.target.closest(
      'button[name="add"], button[type="submit"][name="add"], form[action*="/cart/add"] button[type="submit"]'
    );
    if (!addToCartBtn) return;

    var form = addToCartBtn.closest('form[action*="/cart/add"]');
    if (!form) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var formData = new FormData(form);
    var mainVariantId = formData.get('id');
    var mainQuantity = formData.get('quantity') || 1;

    if (!mainVariantId) return;

    var items = [
      {
        id: mainVariantId,
        quantity: parseInt(mainQuantity, 10)
      },
      {
        id: 51044892213546, // free mala variant ID
        quantity: 1
      }
    ];

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (error) {
            throw error;
          });
        }
        return response.json();
      })
      .then(function () {
        // ✅ Redirect to cart page
        window.location.href = '/cart';
      })
      .catch(function (error) {
        console.error('Error adding to cart:', error);
        alert('There was an error adding items to cart. Please try again.');
      });
  });
});
